export default "__VITE_ASSET__KG_Hcvdc__"